import React from "react";
import { Hero } from "../components/Hero";
import { Testimonials } from "../components/Testimonials";
import { PricingOffer } from "../components/PricingOffer";
import { WhyBuildersLove } from "../components/WhyBuildersLove";
import { FeatureBlocks } from "../components/FeatureBlocks";
import { ProjectGallery } from "../components/ProjectGallery";
import { ProjectCategories } from "../components/ProjectCategories";
import { BonusSection } from "../components/BonusSection";
import { TrustBadges } from "../components/TrustBadges";
import { AiAssistant } from "../components/AiAssistant";
import { ComparisonTable } from "../components/ComparisonTable";
import { Faq } from "../components/Faq";
import { ContactForm } from "../components/ContactForm";
import { Footer } from "../components/Footer";
export function Landing() {
  return <div className="min-h-screen w-full bg-white" data-id="element-196" data-mp="ha21s2zee4h0">
      <div className="bg-brand px-4 py-2.5 text-center font-heading text-xs font-semibold uppercase tracking-wide text-white md:text-base" data-id="element-197" data-mp="m7bw9x1n96bp">
        Limited-time September sale: 60% off — build more, spend less
      </div>
      <Hero data-id="element-198" data-mp="3tfa3dfl2a27w" />
      <main data-id="element-199" data-mp="3tfjxnfd52vje">
        <Testimonials data-id="element-200" data-mp="3tf0btnkdbn03" />
        <PricingOffer id="offer" data-id="element-201" data-mp="3tio6iq1jufge" />
        <WhyBuildersLove data-id="element-202" data-mp="3pdyc75mjh8xl" />
        <FeatureBlocks data-id="element-203" data-mp="3pf9qhzdm1z2y" />
        <ProjectGallery data-id="element-204" data-mp="3pgubaxa4i3nm" />
        <ProjectCategories data-id="element-205" data-mp="3kfwuao0unfnp" />
        <BonusSection data-id="element-206" data-mp="3kgonxtavz3bc" />
        <TrustBadges data-id="element-207" data-mp="3kh7zms9y0vgx" />
        <PricingOffer id="offer-2" data-id="element-208" data-mp="3khzrpt4c0b2g" />
        <AiAssistant data-id="element-209" data-mp="l0rr11o380ih" />
        <ComparisonTable data-id="element-210" data-mp="kz8bjda99thr" />
        <Testimonials data-id="element-211" data-mp="l2mbyfzczsmk" />
        <Faq data-id="element-212" data-mp="gywu09d6w9ai" />
        <ContactForm data-id="element-213" data-mp="gyen8iswicoc" />
      </main>
      <Footer data-id="element-214" data-mp="gzg9zkja4nlw" />
    </div>;
}